













































































































import Vue from 'vue';
import Const, { DIFFICULTY_LEVEL } from '@/classes/const';
import {
  collection,
  DocumentData,
  getDocs,
  getFirestore,
  limit,
  query,
  where,
  orderBy,
  Query,
  startAfter,
  QueryDocumentSnapshot,
} from 'firebase/firestore/lite';
import Convert from '@/classes/convert';
import SaveData from '@/classes/saveData/saveData';
import { UploadedPreset } from '@/classes/interfaces/uploadedPreset';
import LZString from 'lz-string';
import ItemMaster from '@/classes/item/itemMaster';
import ShipMaster from '@/classes/fleet/shipMaster';
import EnemyMaster from '@/classes/enemy/enemyMaster';
import { MasterMap, MasterWorld } from '@/classes/interfaces/master';

const STEP = 20;

export default Vue.extend({
  name: 'SaveDataList',
  components: {},
  data: () => ({
    areaItems: [] as ({ divider: boolean } | { header: string } | { value: number; text: string; group: string })[],
    selectedArea: 11,
    level: DIFFICULTY_LEVEL.HARD,
    levelItems: Const.DIFFICULTY_LEVELS,
    saveData: [] as UploadedPreset[],
    isLoading: false,
    lastMap: 0,
    lastLevel: 0,
    lastDocument: undefined as undefined | QueryDocumentSnapshot<DocumentData>,
  }),
  mounted() {
    this.initWorlds();
    const initialList = this.$store.state.searchedList as UploadedPreset[];
    if (initialList && initialList.length) {
      this.saveData = initialList;
    }
  },
  computed: {
    getCompletedAll() {
      return this.$store.getters.getCompletedAll;
    },
    isEvent(): boolean {
      return Math.floor(this.selectedArea / 10) > 40;
    },
    isSameSearchCondition(): boolean {
      return this.lastMap === this.selectedArea && this.lastLevel === this.level;
    },
    enabledMoreLoad(): boolean {
      return !!this.lastDocument && this.isSameSearchCondition;
    },
  },
  watch: {
    getCompletedAll(value) {
      if (value) {
        this.initWorlds();
      }
    },
  },
  methods: {
    initWorlds() {
      // 海域セレクトボックス初期化
      const items = [];
      const worlds = this.$store.state.worlds as MasterWorld[];
      const masterMaps = this.$store.state.maps as MasterMap[];
      if (worlds && masterMaps) {
        for (let i = 0; i < worlds.length; i += 1) {
          const world = worlds[i];
          const maps = masterMaps.filter((v) => Math.floor(v.area / 10) === world.world);
          if (!maps.length) {
            continue;
          }
          if (i > 0) {
            items.push({ divider: true });
          }

          items.push({ header: world.name });
          for (let j = 0; j < maps.length; j += 1) {
            const map = maps[j];
            const worldText = world.world > 40 ? 'E' : `${world.world}`;
            items.push({ value: map.area, text: `${worldText}-${map.area % 10}：${map.name}`, group: world.name });
          }
        }
      }
      this.areaItems = items;
    },
    changedWorld() {
      this.isLoading = false;
    },
    async searchPreset() {
      this.isLoading = true;
      if (!this.enabledMoreLoad) {
        this.saveData = [];
      }

      try {
        const db = getFirestore();
        const fbLevel = 4 - this.level;
        let q: Query<DocumentData>;
        if (this.isEvent) {
          if (this.lastDocument) {
            q = query(
              collection(db, 'presets'),
              where('map', '==', this.selectedArea),
              where('level', '==', fbLevel),
              orderBy('createdAt', 'desc'),
              startAfter(this.lastDocument),
              limit(STEP),
            );
          } else {
            q = query(
              collection(db, 'presets'),
              where('map', '==', this.selectedArea),
              where('level', '==', fbLevel),
              orderBy('createdAt', 'desc'),
              limit(STEP),
            );
          }
        } else if (this.lastDocument) {
          q = query(
            collection(db, 'presets'),
            where('map', '==', this.selectedArea),
            where('level', '==', 0),
            orderBy('createdAt', 'desc'),
            startAfter(this.lastDocument),
            limit(STEP),
          );
        } else {
          q = query(
            collection(db, 'presets'),
            where('map', '==', this.selectedArea),
            where('level', '==', 0),
            orderBy('createdAt', 'desc'),
            limit(STEP),
          );
        }

        // 今回の検索条件を保持
        this.lastMap = this.selectedArea;
        this.lastLevel = this.level;

        const snapShot = await getDocs(q);
        const fetchData: UploadedPreset[] = [];
        const items = this.$store.state.items as ItemMaster[];
        const ships = this.$store.state.ships as ShipMaster[];
        const enemies = this.$store.state.defaultEnemies as EnemyMaster[];
        const converter = new Convert(items, ships, enemies);
        snapShot.forEach((doc) => {
          // 中間生成物
          const preset = doc.data() as UploadedPreset;
          if (preset.ver === 2) {
            // 新版編成復元
            const managerString = LZString.decompressFromBase64(doc.data().data) || '';
            const manager = SaveData.loadSaveDataManagerString(managerString, items, ships, enemies);
            if (manager) {
              preset.ships = manager.fleetInfo.fleets[0].ships;
              preset.manager = manager;
              preset.createdAt = Convert.formatDate(doc.data().createdAt.toDate(), 'yyyy/MM/dd HH:mm:ss');
              fetchData.push(preset);
            }
          } else {
            // 編成復元
            const manager = converter.restoreOldSaveData(doc.data().data);
            if (manager) {
              preset.ships = manager.fleetInfo.fleets[0].ships;
              preset.manager = manager;
              preset.createdAt = Convert.formatDate(doc.data().createdAt.toDate(), 'yyyy/MM/dd HH:mm:ss');
              fetchData.push(preset);
            }
          }
        });

        if (this.lastDocument && this.saveData) {
          // 追加読み込みの場合はpushする
          this.saveData = this.saveData.concat(fetchData);
        } else {
          this.saveData = fetchData;
        }

        // 追加読み込み制御
        if (snapShot && snapShot.docs.length >= STEP) {
          this.lastDocument = snapShot.docs[snapShot.docs.length - 1];
        } else {
          this.lastDocument = undefined;
        }

        // 次回訪問時復帰するため保持
        this.$store.dispatch('setSearchedList', this.saveData);
      } catch (error) {
        console.error(error);
        this.saveData = [];
        this.$emit('inform', '編成データ読み込み中にエラーが発生しました。', true);
      }
      this.isLoading = false;
    },
    expandPreset(preset: UploadedPreset) {
      const saveData = this.$store.state.saveData as SaveData;
      saveData.disabledMain();

      // ルートに無題のデータを生成
      const data = new SaveData();
      data.name = preset.name;
      data.remarks = preset.memo;
      data.tempData = [preset.manager];
      data.tempIndex = 0;
      data.isActive = true;
      data.isMain = true;
      saveData.childItems.push(data);

      this.$store.dispatch('updateSaveData', saveData);
      this.$store.dispatch('setMainSaveData', data);
      this.$router.push('aircalc');
    },
  },
});
